function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#B3D4FF",
  stroke: "#0041C0",
  strokeWidth: 2,
  d: "M57 50V11.414L47.586 2H19v48h38z"
}), React.createElement("path", {
  fill: "#0041C0",
  fillRule: "nonzero",
  d: "M47 2l5 5 5 5H47z"
}), React.createElement("path", {
  fill: "#B3D4FF",
  stroke: "#0041C0",
  strokeWidth: 2,
  d: "M51 56V17.414L41.586 8H13v48h38z"
}), React.createElement("path", {
  fill: "#0041C0",
  fillRule: "nonzero",
  d: "M41 8l5 5 5 5H41z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#FFF",
  stroke: "#0041C0",
  strokeWidth: 2,
  d: "M45 62V23.414L35.586 14H7v48h38z"
}), React.createElement("g", {
  fill: "#0041C0",
  fillRule: "nonzero",
  transform: "translate(10 26)"
}, React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), React.createElement("path", {
  d: "M28 1h4v2h-4zM6 1h20v2H6z"
})), React.createElement("g", {
  fill: "#0041C0",
  fillRule: "nonzero",
  transform: "translate(10 32)"
}, React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), React.createElement("path", {
  d: "M28 1h4v2h-4zM6 1h20v2H6z"
})), React.createElement("g", {
  fill: "#0041C0",
  fillRule: "nonzero",
  transform: "translate(10 38)"
}, React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), React.createElement("path", {
  d: "M28 1h4v2h-4zM6 1h20v2H6z"
})), React.createElement("g", {
  fill: "#0041C0",
  fillRule: "nonzero",
  transform: "translate(10 44)"
}, React.createElement("circle", {
  cx: 2,
  cy: 2,
  r: 2
}), React.createElement("path", {
  d: "M6 1h20v2H6z"
})), React.createElement("path", {
  fill: "#0041C0",
  fillRule: "nonzero",
  d: "M10 17h4v2h-4zM16 17h4v2h-4zM29 17h4v2h-4zM35 14l5 5 5 5H35z"
})));

var SvgEmptyState = function SvgEmptyState(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmptyState, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emptyState.864d58c2.svg";
export { ForwardRef as ReactComponent };